import Crud from '../components/AditionalHour/Crud'
import Add from '../components/AditionalHour/Add'

let routes = {
    path: '/aditionalHours',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/aditionalHours',
            name: 'Horas adicionais',
            component: Crud
        },
        {
            path: '/aditionalHour/:id?',
            name: 'Hora adicional',
            component: Add
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/aditionalHour.js